import { render, staticRenderFns } from "./StaffTransfers.vue?vue&type=template&id=679f3ef8&"
import script from "./StaffTransfers.vue?vue&type=script&lang=js&"
export * from "./StaffTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports